"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _singleBuilder = require("./singleBuilder");
Object.keys(_singleBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _singleBuilder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _singleBuilder[key];
    }
  });
});